import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "./App.css";
import { AuthProvider, useAuth } from "./lib/auth";
import { I18nProvider } from "./lib/i18n";
import { Layout } from "./components/Layout";
import Home from "./pages/Home";
import Airport from "./pages/Airport";
import Login from "./pages/Login";
import Register from "./pages/Register";
import CustomerDashboard from "./pages/CustomerDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import PaymentStatus from "./pages/PaymentStatus";
import Legal from "./pages/Legal";

function Private({ children, admin = false }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-[60vh] flex items-center justify-center text-white/50">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/airports/:slug" element={<Airport />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/dashboard" element={<Private><CustomerDashboard /></Private>} />
        <Route path="/admin" element={<Private admin><AdminDashboard /></Private>} />
        <Route path="/payment/return" element={<PaymentStatus />} />
        <Route path="/legal/:slug" element={<Legal />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}

export default function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster position="top-right" theme="dark" richColors />
        </BrowserRouter>
      </AuthProvider>
    </I18nProvider>
  );
}
